export default __webpack_public_path__ + "static/media/resume.be2f769e.png";